export default __webpack_public_path__ + "cb340c260da260f5f91a30f8927ac418.png";